/* eslint-disable max-len */
import React, { SVGProps } from 'react';

export const DeleteDataIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		width="15"
		viewBox="3.33 1.67 13.33 16.67"
		{...props}>
		<path
			d="M11.6667 1.66669H5.00004C4.55801 1.66669 4.13409 1.84228 3.82153 2.15484C3.50897 2.4674 3.33337 2.89133 3.33337 3.33335V16.6667C3.33337 17.1087 3.50897 17.5326 3.82153 17.8452C4.13409 18.1578 4.55801 18.3334 5.00004 18.3334H15C15.4421 18.3334 15.866 18.1578 16.1786 17.8452C16.4911 17.5326 16.6667 17.1087 16.6667 16.6667V6.66669L11.6667 1.66669ZM15 16.6667H5.00004V3.33335H10.8334V7.50002H15"
			fill="#768D95"
		/>
		<path
			d="M12.6603 10.7322L10.8925 12.5L12.6603 14.2678L11.4818 15.4463L9.71399 13.6785L7.94622 15.4463L6.76771 14.2678L8.53548 12.5L6.76771 10.7322L7.94622 9.55372L9.71399 11.3215L11.4818 9.55372L12.6603 10.7322Z"
			fill="#768D95"
		/>
	</svg>
);
